'use client';

import React from 'react';

import { AnalyticsProvider } from '~/app/lib/segment/AnalyticsProvider';

export function AnalyticsWrapper({ children }: any) {
  return <AnalyticsProvider>{children}</AnalyticsProvider>;
}
